import { getComponentClasses } from '@99designs/common/utils/app';
import React from 'react';
import { Link as ReactRouterLink, LinkProps } from 'react-router-dom';

interface Props extends LinkProps {
    variations?: ['back', 'big-target'];
}

const Link: React.SFC<Props> = ({ children, variations, ...props }) => {
    const classes = getComponentClasses('link', variations);

    return (
        <ReactRouterLink className={classes} {...props}>
            {children}
        </ReactRouterLink>
    );
};

export default Link;
